export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    id: "f1",
    q: "「美味的快递」主要测评哪些内容？",
    a: "我们围绕外卖测评、探店实录、美食开箱与家常复刻四条线展开。外卖侧重出餐速度、送达完整度与性价比；探店看重现场体验与招牌菜；开箱关注还原度、分量和保存方式；家常复刻则给出可操作的步骤与成本。",
  },
  {
    id: "f2",
    q: "测评的评分是怎么给出的？",
    a: "评分由四个维度加权得出：口味占 40%、性价比占 25%、出餐或配送体验占 20%、复购意愿占 15%。同一品类会尽量安排同一时段、同一地址对比，减少环境干扰，但个体口味差异依然存在，评分仅供参考。",
  },
  {
    id: "f3",
    q: "可以直接通过你们下单或预订吗？",
    a: "本页只做内容测评与推荐，不提供下单、预订或支付功能。文中的价格、营业时间等信息来自测评当时的记录，实际可能变化，出发前建议再确认一次。",
  },
  {
    id: "f4",
    q: "开箱测评里的「推荐回购」是怎么判断的？",
    a: "「推荐回购」需要同时满足：还原度接近堂食或现做水准、分量与标称一致、加热或复烤操作简单、价格具备优势。只满足其中一两项的，会被归到「可以尝鲜」，存在明显短板的则提示「谨慎选择」。",
  },
  {
    id: "f5",
    q: "你们接受商家投稿或者读者推荐吗？",
    a: "欢迎读者推荐想看的店铺和商品，也接受商家提供样品供独立测评。所有测评结论都由测评小组独立给出，不因样品来源改变评价标准；是否存在合作会明确标注。",
  },
];